export default "__VITE_ASSET__Bx93sizY__"